/** @jsxImportSource @emotion/react */
import { dropdownContainer, dropdownSelect, divider, listContainer } from '../styles/DataSelectionSection.styles';
import { dataList } from 'components/lab/lab_1/point_data/dataList';
import Checkbox from 'components/lab/lab_1/point_data/checkbox/Checkbox';
import RadioButton from 'components/lab/lab_1/point_data/checkbox/RadioButton';
import CollapsibleSection from './CollapsibleSection';

const DataSelectionSection = ({
    selectedData,
    setSelectedData,
    selectedSubArray,
    handleCheckboxChange,
    handleRadioChange,
}) => {
    const handleDataChange = (event) => {
        const selectedDataName = event.target.value;
        const data = dataList.find((d) => d.name === selectedDataName);
        if (data) {
            setSelectedData(data);
        }
    };

    return (
        <CollapsibleSection title="데이터 선택" defaultExpanded={true}>
            <div css={dropdownContainer}>
                <select css={dropdownSelect} value={selectedData?.name || ''} onChange={handleDataChange}>
                    <option value="">데이터를 선택하세요</option>
                    {dataList.map((data, idx) => (
                        <option key={idx} value={data.name}>
                            {data.name}
                        </option>
                    ))}
                </select>
            </div>

            <div css={divider}></div>

            {/* 하위분류 선택 */}
            {selectedSubArray && selectedSubArray.length > 0 && (
                <div css={listContainer}>
                    {selectedSubArray.map((data) => {
                        if (selectedData.selectType === 'checkbox') {
                            return (
                                <Checkbox
                                    key={data.id}
                                    name={data.name}
                                    checked={data.checked}
                                    onChange={() => handleCheckboxChange(data)}
                                />
                            );
                        } else if (selectedData.selectType === 'radio') {
                            return (
                                <RadioButton
                                    key={data.id}
                                    name={data.name}
                                    checked={data.checked}
                                    onChange={() => handleRadioChange(data)}
                                />
                            );
                        } else {
                            return null;
                        }
                    })}
                </div>
            )}
        </CollapsibleSection>
    );
};

export default DataSelectionSection;
